module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_kids-3bc7d8488203f144be157bc69e01cadb.svg";